import { useQuery, useQueryClient } from "@tanstack/react-query";
import { boronClient } from "../../../api";
import { createError } from "../../../errors";
import { KarteTemplateInterface } from "../../../interfaces/KarteTemplateInterface";

const path =
  "/api/v1/sections/{section_id}/karte_templates/{karte_template_hashid}" as const;

const buildQueryKey = (sectionId: string, karteTemplateId: string) => [
  path,
  sectionId,
  karteTemplateId,
];

interface UseFetchSectionKarteTemplateParams {
  sectionId: string;
  karteTemplateId: string;
}

export const useFetchSectionKarteTemplate = ({
  sectionId,
  karteTemplateId,
}: UseFetchSectionKarteTemplateParams) => {
  return useQuery<KarteTemplateInterface>({
    queryKey: buildQueryKey(sectionId, karteTemplateId),
    queryFn: async () => {
      const { response, data } = await boronClient.GET(path, {
        params: {
          path: {
            section_id: sectionId,
            karte_template_hashid: karteTemplateId,
          },
        },
      });
      if (response.ok && data) {
        return data.karteTemplate;
      }
      throw await createError(response);
    },
  });
};

export const useSectionKarteTemplateCacheUpdater = () => {
  const queryClient = useQueryClient();

  const updateSectionKarteTemplate = (
    sectionId: string,
    karteTemplate: KarteTemplateInterface,
  ) => {
    queryClient.setQueryData(
      buildQueryKey(sectionId, karteTemplate.id),
      karteTemplate,
    );
  };

  const removeSectionKarteTemplate = (
    sectionId: string,
    karteTemplateId: string,
  ) => {
    queryClient.removeQueries({
      queryKey: buildQueryKey(sectionId, karteTemplateId),
    });
  };

  return {
    updateSectionKarteTemplate,
    removeSectionKarteTemplate,
  };
};
